import { createFileRoute } from '@tanstack/react-router';
import { loadProfileMessages, loadProfileScreens, profileScreen, profileSearch } from '@/modules/profile/route';
import { lazyScreen } from '@/shared/screen';

export const Route = createFileRoute('/_app/meu-perfil/')({
  validateSearch: profileSearch,
  staticData: { screen: profileScreen },
  loader: () => loadProfileMessages(),
  component: lazyScreen(loadProfileScreens, 'ProfileScreen'),
});
